module.exports = false;



//////////////////
// WEBPACK FOOTER
// /builds/mediaclinicstn/stampling-viewer/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0